export default "__VITE_ASSET__C$G6dcW4__"